module.exports = __webpack_public_path__ + "static/media/BETU.95613bad.png";